// extracted by mini-css-extract-plugin
export default {"custom":"CustomScene_custom__fiPA4","custom_p":"CustomScene_custom_p__gTIQj"};